import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { introTextRevealAnimation } from './animations'
import { cn } from '@/lib/utils'

export type IntroTextProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    title: string
    subtitle: string
    paragraph: string
    is_heading: boolean
  }>

const IntroText = ({
  title,
  subtitle,
  paragraph,
  is_heading = true,
  ...props
}: IntroTextProps) => {
  return (
    <Motion animation={introTextRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Container>
            <Grid>
              <div
                className={cn(
                  'col-span-2 md:col-span-6 lg:col-span-6',
                  'flex flex-col gap-y-[2.4rem]'
                )}
              >
                {title ? (
                  <Typography
                    variant={is_heading ? 'h2' : 'h4'}
                    component="h2"
                    className={cn([
                      { 'font-medium text-text-accent-light': is_heading }
                    ])}
                    data-motion-title
                  >
                    {title}
                  </Typography>
                ) : null}

                {subtitle ? (
                  <Typography
                    variant="large"
                    paragraph
                    className="lg:pt-spacing-xs"
                    data-motion-subtitle
                  >
                    {subtitle}
                  </Typography>
                ) : null}

                {paragraph ? (
                  <Typography variant="regular" paragraph data-motion-paragraph>
                    {paragraph}
                  </Typography>
                ) : null}
              </div>
            </Grid>
          </Container>
        </Section>
      )}
    </Motion>
  )
}

export default IntroText
